import { render, staticRenderFns } from "./EachCountryGreetings.vue?vue&type=template&id=643035a0&scoped=true&"
import script from "./EachCountryGreetings.vue?vue&type=script&lang=js&"
export * from "./EachCountryGreetings.vue?vue&type=script&lang=js&"
import style0 from "./EachCountryGreetings.vue?vue&type=style&index=0&id=643035a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643035a0",
  null
  
)

export default component.exports